import { DeleteHealthSystemPopupProps } from './types'
import { useRFPDetailsPopupContext } from '../Providers/RFPDetailsPopupProvider'
import { useRFPDetailsContext } from '../Providers/RFPDetailsContextProvider'
import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { setLoading } from 'redux/store/common/slice'
import { Tooltip } from 'components/Tooltip/Tooltip'
import Button from '../../../../components/Button/Button'
import { BUTTON_TYPES } from 'components/Button/constants'
import { BTN_TXT, TOOLTIP } from '../../../../constants'
import { ReactComponent as Delete16 } from 'assets/svg/Delete16.svg'
import { Popup } from '../../../../components/Popup'
import { Typography } from 'components/Typography'
import { deleteRfpHS } from '../api'

export const DeleteHealthSystemPopup = ({
  updateHSList,
  selectedHS,
  disableButton
}: DeleteHealthSystemPopupProps) => {
  const { deleteHealthSystemsPopup } = useRFPDetailsPopupContext()
  const { state, actions } = deleteHealthSystemsPopup
  const { open, close } = actions
  const { visible } = state
  const { state: stateRfp } = useRFPDetailsContext()
  const { data } = stateRfp
  const dispatch = useDispatch()

  const handleDeleteUsers = useCallback(async () => {
    if (!data.uuid) {
      throw new Error('RFP ID not provided')
    }
    try {
      dispatch(setLoading(true))
      await deleteRfpHS(
        data.uuid,
        {
          health_systems: selectedHS
            .filter((selectedRow) => !selectedRow.hospital_level)
            .map((selectedRow) => selectedRow.uuid),
          hospitals: selectedHS
            .filter((selectedRow) => selectedRow.hospital_level)
            .map((selectedRow) => selectedRow.uuid)
        },
        `${selectedHS.length > 1 ? 'Facilities' : 'Facility'} ${
          selectedHS.length > 1 ? 'have' : 'has'
        } been successfully deleted.`
      )
      updateHSList()
      closeDeletePopup()
    } finally {
      dispatch(setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dispatch, updateHSList, selectedHS])

  const openDeletePopup = () => open()

  const closeDeletePopup = () => close()

  return (
    <>
      {!!selectedHS.length && (
        <Tooltip title={disableButton ? TOOLTIP.DISABLE_DELETE_HS : null}>
          <div>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={openDeletePopup}
              icon={<Delete16 />}
              disabled={disableButton}
              upperCase
              danger
            >
              {BTN_TXT.DELETE}
            </Button>
          </div>
        </Tooltip>
      )}
      <Popup
        visible={visible}
        onCancel={closeDeletePopup}
        title={`Delete ${selectedHS.length === 1 ? 'Facility' : 'Facilities'}?`}
        width={442}
        footer={
          <>
            <Button
              type={BUTTON_TYPES.DEFAULT}
              onClick={closeDeletePopup}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={handleDeleteUsers}
              upperCase
              danger
            >
              {BTN_TXT.DELETE}
            </Button>
          </>
        }
      >
        <Typography.Body1>
          {selectedHS.length === 1
            ? `Facility`
            : `${selectedHS.length} Facilities`}{' '}
          will be removed from the {data.name} RFP.
        </Typography.Body1>
      </Popup>
    </>
  )
}
